<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.USER' | translate }}</h1>
                <div class="content" *ngIf="userPermissions.includes(permissions.WriteUser) && !isPrivateTenant">
                    <button
                        *ngIf="!isUnrestricted"
                        (click)="openAddUserToTenantPanel()"
                        class="secondary"
                        type="button"
                    >
                        {{ 'BUTTONS.ADD_EXISTING_USER' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> person_add </span>
                    </button>
                    <button (click)="openCreateUserModal()" class="primary" type="button">
                        {{ 'BUTTONS.CREATE_USER' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                    </button>
                </div>
            </app-form-row>
            <app-form-row>
                <app-search-input formControlName="searchPhrase" />
            </app-form-row>
        </app-form-section>
    </form>
</app-filter-container>
<app-table [loading]="loading" [clickable]="true">
    <tr thead>
        <app-table-header
            [isActive]="sortKey === 'firstName'"
            [defaultAscending]="sortKey === 'firstName' && sortAscending"
            [sort]="true"
            [width]="16"
            [text]="'FEATURES.USER.COLUMNS.FIRST_NAME' | translate"
            (sortChanged)="onSortChange('firstName', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'lastName'"
            [defaultAscending]="sortKey === 'lastName' && sortAscending"
            [sort]="true"
            [width]="16"
            [text]="'FEATURES.USER.COLUMNS.LAST_NAME' | translate"
            (sortChanged)="onSortChange('lastName', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'email'"
            [defaultAscending]="sortKey === 'email' && sortAscending"
            [sort]="true"
            [dynamicWidth]="50"
            [text]="'FEATURES.USER.COLUMNS.EMAIL' | translate"
            (sortChanged)="onSortChange('email', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'phone'"
            [defaultAscending]="sortKey === 'phone' && sortAscending"
            [sort]="true"
            [width]="14"
            [text]="'FEATURES.USER.COLUMNS.PHONE' | translate"
            (sortChanged)="onSortChange('phone', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'roles'"
            [defaultAscending]="sortKey === 'roles' && sortAscending"
            [width]="20"
            [text]="'FEATURES.USER.COLUMNS.ROLES' | translate"
            (sortChanged)="onSortChange('roles', $event)"
        />
        <app-table-header
            *ngIf="isUnrestricted"
            [isActive]="sortKey === 'tenants'"
            [defaultAscending]="sortKey === 'tenants' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'GENERAL.TENANT' | translate"
            (sortChanged)="onSortChange('tenants', $event)"
        />
        <app-table-header [align]="align.Center" [width]="12" *appHasPermissions="[permissions.WriteUser]" />
    </tr>
    <ng-container tbody>
        <tr *ngFor="let item of users$ | async" (click)="openCreateUserModal(item)">
            <td>{{ item.firstName }}</td>
            <td>{{ item.lastName }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.roles | roles }}</td>
            <td *ngIf="isUnrestricted" [appTooltip]="item.tenants" [tooltipPosition]="'left'">{{ item.tenants }}</td>
            <td class="right" *appHasPermissions="[permissions.WriteUser]">
                <div *ngIf="isUnrestricted">
                    <button
                        *ngIf="item.isRemovableFromTenant"
                        [appTooltip]="'FEATURES.USER.TOOLTIPS.REMOVE_FROM_UNRESTRICTED' | translate"
                        [tooltipPosition]="'left'"
                        (click)="confirmDeleteUser($event, item, false)"
                        class="icon"
                        [ngClass]="{ loading: loadingUserIds.includes(item.id) }"
                    >
                        <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                    </button>
                    <button
                        *ngIf="item.isDeletable"
                        [appTooltip]="'FEATURES.USER.TOOLTIPS.REMOVE_FROM_SYSTEM' | translate"
                        [tooltipPosition]="'left'"
                        (click)="confirmDeleteUser($event, item, true)"
                        class="icon red"
                        [ngClass]="{ loading: loadingUserIds.includes(item.id) }"
                    >
                        <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                    </button>
                </div>
                <button
                    *ngIf="!isUnrestricted"
                    [appTooltip]="'FEATURES.USER.TOOLTIPS.DELETE_USER' | translate"
                    [tooltipPosition]="'left'"
                    (click)="confirmDeleteUser($event, item, item.isDeletable)"
                    class="icon"
                    [ngClass]="{ loading: loadingUserIds.includes(item.id) }"
                >
                    <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                </button>
            </td>
        </tr>
    </ng-container>
</app-table>
